import { render, staticRenderFns } from "./WidgetCarouselGeneralSettings.vue?vue&type=template&id=72e4f2c3&scoped=true"
import script from "./WidgetCarouselGeneralSettings.vue?vue&type=script&lang=js"
export * from "./WidgetCarouselGeneralSettings.vue?vue&type=script&lang=js"
import style0 from "./WidgetCarouselGeneralSettings.vue?vue&type=style&index=0&id=72e4f2c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e4f2c3",
  null
  
)

export default component.exports